'use client'
import { useState, useEffect } from 'react'
import { useRouter } from 'next/navigation'
import { RadioGroup } from '@headlessui/react'

import { getSearchParams } from "@utils";
import { categoryTypes } from '@constants/categoryTypes';


const CategoryFilter = ({ title, lang, dictionary }) => {
    const router = useRouter();
    let [category, setCategory] = useState(categoryTypes[lang][0])
    let [addChecked, setAddChecked] = useState(categoryTypes[lang][0].value)


    const handleUpdateParams = (e) => {
        let categoryQuery = ''
        const category = e.value
        if (category !== 'all') categoryQuery = `&category=${category}`

        let saleQuery = ''
        const saleType = getSearchParams('saleType')
        if (saleType !== null) saleQuery = `saleType=${saleType}`

        let minpriceQuery = ''
        const minprice = getSearchParams('minprice')
        if (minprice !== null) minpriceQuery = `&minprice=${minprice}`

        let maxpriceQuery = ''
        const maxprice = getSearchParams('maxprice')
        if (maxprice !== null) maxpriceQuery = `&maxprice=${maxprice}`

        let btsQuery = ''
        const bts = getSearchParams('bts')
        if (bts !== null) btsQuery = `&bts=${bts}`

        let mapQuery = ''
        const map = getSearchParams('map')
        if (map !== null) mapQuery = `&map=${map}`

        let sortQuery = ''
        const sort = getSearchParams('sort')
        if (sort !== null) sortQuery = `&sort=${sort}`

        const updatedPathname = `${window.location.pathname}?${saleQuery}${categoryQuery}${minpriceQuery}${maxpriceQuery}${btsQuery}${mapQuery}${sortQuery}`
        // console.log(updatedPathname)

        // let newPathName
        // if (e.value == 'all') {
        //     newPathName = removeSearchParam(title);
        // } else {
        //     newPathName = updateSearchParams(title, e.value);
        // }
        const newPathName = updatedPathname

        router.push(newPathName);
        router.refresh()
    };

    useEffect(() => {
        const categoryValue = getSearchParams('category')
        setAddChecked(categoryValue)
        const newValue = categoryTypes[lang].find(obj => obj.value === addChecked);
        // console.log('new value ' + newValue)
        if (newValue != undefined) {
            setCategory(newValue)
        } else {
            setCategory(categoryTypes[lang][0])
        }

    }, [handleUpdateParams])

    return (
        <div className="w-full">
            <span className='text-sm text-secondary'>{dictionary.filter.category}:</span>
            <div className="w-full">
                <RadioGroup value={category} onChange={(value) => {
                    setCategory(value)
                    handleUpdateParams(value)
                }}
                    className='w-full py-1 mt-1 flex flex-row'
                >
                    {categoryTypes[lang].map((categoryType) => (
                        <RadioGroup.Option
                            key={categoryType.value}
                            value={categoryType}
                            checked={categoryType === category}
                            className={({ active, checked }) =>
                                `${active
                                    ? ''
                                    : ''
                                }
                                    ${checked ? 'bg-maincolor text-light' : 'bg-light'
                                }
                                    w-full relative flex cursor-pointer round-style px-2 py-2 shadow-md focus:outline-none`
                            }
                        >
                            {({ active, checked }) => (
                                <>
                                    <div className="flex w-full items-center justify-between">
                                        <div className="flex items-center">
                                            <div className="text-sm text-center">
                                                <RadioGroup.Label
                                                    as="p"
                                                    className={`font-medium w-full  ${checked ? 'text-light' : 'text-maincolor'
                                                        }`}
                                                >
                                                    {categoryType.title}
                                                </RadioGroup.Label>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )}
                        </RadioGroup.Option>
                    ))}
                </RadioGroup>
            </div>
        </div>
    )

    // return (
    //     <RadioGroup value={sale} onChange={(e) => {
    //         setSale
    //         handleUpdateParams(e)
    //     }} className='w-full px-2 mt-2 flex flex-row justify-between'>
    //         {/* <RadioGroup.Label>Plan</RadioGroup.Label> */}
    //         <RadioGroup.Option value="sale" className='w-full border-[1px] rounded-l-md border-maincolor'>
    //             {({ active, checked }) => (
    //                 <div className={`w-full text-center py-2 ${checked ? 'bg-maincolor' : ''}`}>
    //                     <span className={checked ? 'text-light' : 'text-maincolor'}>For Sale</span>
    //                 </div>
    //             )}
    //         </RadioGroup.Option>
    //         <RadioGroup.Option value="rent" className={`w-full border-[1px] rounded-r-md border-maincolor`} >
    //             {({ active, checked }) => (
    //                 <div className={`w-full text-center py-2 ${checked ? 'bg-maincolor' : ''}`}>
    //                     <span className={checked ? 'text-light' : 'text-maincolor'}>For Rent</span>
    //                 </div>
    //             )}
    //         </RadioGroup.Option>
    //     </RadioGroup>
    // )
}

export default CategoryFilter